<template>
  <div class="service-file-list">
    <div
      class="item"
      v-for="(item, index) in list.filter((e, index) => index < (open ? list.length : 5))"
      :key="index"
    >
      <FileListItemPdf :item="item" v-if="item.type === 'PDF'" />
      <FileListItemVideo :item="item" v-if="item.type === 'VIDEO'" />
      <FileListItemAudio :item="item" v-if="item.type === 'AUDIO'" />
      <FileListItemImage :item="item" v-if="item.type === 'IMAGE'" />
    </div>
    <div class="open" v-if="!open" @click="onOpen" v-show="list.length > 5">
      <img src="@/assets/service/全部.png" alt />
      <div>全部{{name}}（{{list.length}}）</div>
    </div>
    <div class="close" v-else @click="onClose" v-show="list.length > 5">
      <img src="@/assets/service/收起.png" alt />
      <div>收起</div>
    </div>
  </div>
</template>

<script>
import FileListItem from "./FileListItem";
import FileListItemAudio from "./FileListItemAudio";
import FileListItemImage from "./FileListItemImage";
import FileListItemPdf from "./FileListItemPdf";
import FileListItemVideo from "./FileListItemVideo";

export default {
  name: "FileList",
  components: {
    FileListItem,
    FileListItemAudio,
    FileListItemImage,
    FileListItemPdf,
    FileListItemVideo
  },
  props: {
    name: {
      type: String,
      default: "文件"
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    onOpen() {
      this.open = true;
    },
    onClose() {
      this.open = false;
    }
  }
};
</script>

<style lang="scss">
.service-file-list {
  width: 100%;

  .item {
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 20px;

    vertical-align: top;
  }

  .open,
  .close {
    width: 100px;
    height: 180px;
    background: rgba(247, 250, 248, 1);
    border-radius: 5px;

    display: inline-block;

    vertical-align: top;

    text-align: center;

    cursor: pointer;
    user-select: none;

    img {
      margin-top: 70px;
      width: 20px;
    }

    div {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(27, 153, 79, 1);
      line-height: 17px;
    }
  }
}
</style>